import { BizParkConfig } from 'src/components/biz-dialog-park-config';

export default BizParkConfig;
